import { IconRuleSet } from '@vfuk/core-icon-generator/dist/IconGenerator.types'
import { Theme } from '@vfuk/core-themes/dist/themes.types'

// Setting up nonThemeableRules for use within the React component generator
export const nonThemeableRules = {
  packageName: 'SourceSystemIcons',
  colorAppliesTo: 'stroke',
  strokeWidth: '1px',
  defaultSize: 3,
  hasNumberBadge: true,
  size: {
    1: {
      sm: 16,
      md: 16,
      lg: 16,
      xl: 16,
    },
    2: {
      sm: 20,
      md: 20,
      lg: 20,
      xl: 20,
    },
    3: {
      sm: 20,
      md: 24,
      lg: 24,
      xl: 24,
    },
    4: {
      sm: 24,
      md: 32,
      lg: 32,
      xl: 32,
    },
    5: {
      sm: 32,
      md: 36,
      lg: 36,
      xl: 36,
    },
  },
  appearance: {
    primary: {
      inverse: {},
    },
    secondary: {
      inverse: {},
    },
  },
  state: {
    success: {},
    error: {},
    info: {},
    warn: {},
  },
}

const ruleSet = (theme: Theme): IconRuleSet => {
  // deep clone the nonThemeableRules to modify them in side this function
  const rules = JSON.parse(JSON.stringify(nonThemeableRules))

  // Applying themeable rules
  rules.appearance = {
    primary: {
      color: theme.color.monochrome6.default,
      inverse: {
        color: theme.inverseColor.monochrome6.default,
      },
    },
    secondary: {
      color: theme.color.primary1.default,
      inverse: {
        color: theme.inverseColor.primary1.default,
      },
    },
  }

  rules.state = {
    success: {
      color: theme.color.success.default,
    },
    error: {
      color: theme.color.error.default,
    },
    info: {
      color: theme.color.info.default,
    },
    warn: {
      color: theme.color.warn.default,
    },
  }

  return rules
}

export default ruleSet
